<sphere-timezone-form
    [formGroup]="formGroup"
    [controlName]="key.toString()"
    [hint]="props.description || ''"
    [label]="props?.label || ''"
></sphere-timezone-form>
